<script lang="ts">
	import type { Snippet } from "svelte";
	import { ImageFit } from "@core/schema/ImageFit.js";
	import type { Reference } from "@core/schema/Reference.js";
	import { getReferenceDetailPath } from "@core/schema/paths/getReferenceDetailPath.js";
	import Link from "./common/Link.svelte";
	import Media from "./common/Media.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const {
		reference,
		name,
		desc,
		reversed,
	}: {
		reference: Reference;
		name: Snippet;
		desc: Snippet;
		reversed?: boolean;
	} = $props();

	const href = $derived(reference.caseStudy ? getReferenceDetailPath(reference) : undefined);
</script>

<div
	class={[
		"mb-16 lg:mb-20 flex flex-col gap-4 lg:gap-[4.5rem] items-center",
		reversed ? "xl:flex-row" : "xl:flex-row-reverse",
		"lg:w-full lg:justify-between lg:items-center container-8",
	]}
>
	<div class="max-w-[30.81rem] text-left">
		<h3 class="mb-4">{@render name()}</h3>
		<p class:mb-0={!href}>
			{@render desc()}
		</p>

		{#if href}
			<Link {href} variant={ButtonVariant.GreenOutlineLightBgMedium}>Celá reference</Link>
		{/if}
	</div>

	<div class="shrink-0 lg:w-[27.81rem]">
		{#if reference.image}
			<Media
				class={[
					"rounded-[1.25rem] aspect-square",
					reference.imageFit === ImageFit.Contain ? "object-contain" : "object-cover",
				]}
				source={reference.image}
				sourcesets={{
					"<md": [0, 345],
					"<lg": [0, 400],
					">lg": [0, 445],
				}}
				alt=""
				width={445}
				height={445}
			/>
		{/if}
	</div>
</div>
